// pulled from princeton review website
// feel free to add more later
// if time allows, we could make an actual table and reference it in the education section,
// but not worth the time investment
const commonMajors = [
    "Accounting",
    "Actuarial Science",
    "Advertising Major",
    "Aerospace Engineering",
    "African Languages, Literatures, and Linguistics",
    "African Studies",
    "African-American Studies",
    "Agricultural Business and Management",
    "Agricultural Economics",
    "Agricultural Education",
    "Agricultural Journalism",
    "Agricultural Mechanization Major",
    "Agricultural Technology Management",
    "Agricultural/Biological Engineering and Bioengineering",
    "Agriculture",
    "Agronomy and Crop Science",
    "Air Traffic Control",
    "American History",
    "American Literature",
    "American Sign Language",
    "American Studies",
    "Anatomy",
    "Ancient Studies",
    "Animal Behavior and Ethology",
    "Animal Science",
    "Animation and Special Effects",
    "Anthropology",
    "Applied Mathematics",
    "Aquaculture",
    "Aquatic Biology",
    "Arabic",
    "Archeology",
    "Architectural Engineering",
    "Architectural History",
    "Architecture",
    "Art",
    "Art Education",
    "Art History",
    "Art Therapy",
    "Artificial Intelligence and Robotics",
    "Asian-American Studies",
    "Astronomy",
    "Astrophysics",
    "Athletic Training",
    "Atmospheric Science",
    "Automotive Engineering",
    "Aviation",
    "Bakery Science",
    "Biblical Studies",
    "Biochemistry",
    "Bioethics",
    "Biology",
    "Biomedical Engineering",
    "Biomedical Science",
    "Biopsychology",
    "Biotechnology",
    "Botany/Plant Biology",
    "Business Administration/Management",
    "Business Communications",
    "Business Education",
    "Canadian Studies",
    "Caribbean Studies",
    "Cell Biology Major",
    "Ceramic Engineering",
    "Ceramics",
    "Chemical Engineering Major",
    "Chemical Physics",
    "Chemistry Major",
    "Child Care",
    "Child Development",
    "Chinese",
    "Chiropractic",
    "Church Music",
    "Cinematography and Film/Video Production",
    "Circulation Technology",
    "Civil Engineering",
    "Classics",
    "Clinical Psychology",
    "Cognitive Psychology",
    "Communication Disorders",
    "Communications Studies/Speech Communication and Rhetoric",
    "Comparative Literature",
    "Computer and Information Science",
    "Computer Engineering",
    "Computer Graphics",
    "Computer Science",
    "Computer Systems Analysis Major",
    "Construction Management",
    "Counseling",
    "Crafts",
    "Creative Writing",
    "Criminal Science",
    "Criminology",
    "Culinary Arts",
    "Dance",
    "Data Processing",
    "Dental Hygiene",
    "Developmental Psychology",
    "Diagnostic Medical Sonography",
    "Dietetics",
    "Digital Communications and Media/Multimedia",
    "Drawing",
    "Early Childhood Education",
    "East Asian Studies",
    "East European Studies",
    "Ecology",
    "Economics Major",
    "Education",
    "Education Administration",
    "Education of the Deaf",
    "Educational Psychology",
    "Electrical Engineering",
    "Elementary Education",
    "Engineering Mechanics",
    "Engineering Physics",
    "English",
    "English Composition",
    "English Literature Major",
    "Entomology",
    "Entrepreneurship Major",
    "Environmental Design/Architecture",
    "Environmental Science",
    "Environmental/Environmental Health Engineering",
    "Epidemiology",
    "Equine Studies",
    "Ethnic Studies",
    "European History",
    "Experimental Pathology",
    "Experimental Psychology",
    "Fashion Design",
    "Fashion Merchandising",
    "Feed Science",
    "Fiber, Textiles, and Weaving Arts",
    "Film",
    "Finance",
    "Floriculture",
    "Food Science",
    "Forensic Science",
    "Forestry",
    "French",
    "Furniture Design",
    "Game Design",
    "Gay and Lesbian Studies",
    "Genetics",
    "Geography",
    "Geological Engineering",
    "Geology",
    "Geophysics",
    "German",
    "Gerontology",
    "Government Major",
    "Graphic Design",
    "Health Administration",
    "Hebrew",
    "Hispanic-American, Puerto Rican, and Chicano Studies",
    "Historic Preservation",
    "History",
    "Home Economics",
    "Horticulture",
    "Hospitality",
    "Human Development",
    "Human Resources Management Major",
    "Illustration",
    "Industrial Design",
    "Industrial Engineering",
    "Industrial Management",
    "Industrial Psychology",
    "Information Technology",
    "Interior Architecture",
    "Interior Design",
    "International Agriculture",
    "International Business",
    "International Relations",
    "International Studies",
    "Islamic Studies",
    "Italian",
    "Japanese",
    "Jazz Studies",
    "Jewelry and Metalsmithing",
    "Jewish Studies",
    "Journalism",
    "Kinesiology",
    "Korean",
    "Land Use Planning and Management",
    "Landscape Architecture",
    "Landscape Horticulture",
    "Latin American Studies",
    "Library Science",
    "Linguistics",
    "Logistics Management",
    "Management Information Systems",
    "Managerial Economics",
    "Marine Biology Major",
    "Marine Science",
    "Marketing Major",
    "Mass Communication",
    "Massage Therapy",
    "Materials Science",
    "Mathematics",
    "Mechanical Engineering",
    "Medical Technology",
    "Medieval and Renaissance Studies",
    "Mental Health Services",
    "Merchandising and Buying Operations",
    "Metallurgical Engineering",
    "Microbiology",
    "Middle Eastern Studies",
    "Military Science",
    "Mineral Engineering",
    "Missions",
    "Modern Greek",
    "Molecular Biology",
    "Molecular Genetics",
    "Mortuary Science",
    "Museum Studies",
    "Music",
    "Music Education",
    "Music History Major",
    "Music Management",
    "Music Therapy",
    "Musical Theater",
    "Native American Studies",
    "Natural Resources Conservation",
    "Naval Architecture",
    "Neurobiology",
    "Neuroscience",
    "Nuclear Engineering",
    "Nursing Major",
    "Nutrition",
    "Occupational Therapy",
    "Ocean Engineering",
    "Oceanography",
    "Operations Management",
    "Organizational Behavior Studies",
    "Painting",
    "Paleontology",
    "Pastoral Studies",
    "Peace Studies",
    "Petroleum Engineering",
    "Pharmacology",
    "Pharmacy",
    "Philosophy",
    "Photography",
    "Photojournalism Major",
    "Physical Education",
    "Physical Therapy",
    "Physician Assistant",
    "Physics",
    "Physiological Psychology",
    "Piano",
    "Planetary Science",
    "Plant Pathology",
    "Playwriting and Screenwriting",
    "Political Communication",
    "Political Science Major",
    "Portuguese",
    "Pre-Dentistry",
    "Pre-Law",
    "Pre-Medicine",
    "Pre-Optometry",
    "Pre-Seminary",
    "Pre-Veterinary Medicine",
    "Printmaking",
    "Psychology",
    "Public Administration",
    "Public Health",
    "Public Policy Analysis",
    "Public Relations Major",
    "Radio and Television",
    "Radiologic Technology",
    "Range Science and Management",
    "Real Estate",
    "Recording Arts Technology",
    "Recreation Management",
    "Rehabilitation Services",
    "Religious Studies",
    "Respiratory Therapy",
    "Risk Management",
    "Rural Sociology",
    "Russian",
    "Scandinavian Studies",
    "Sculpture",
    "Slavic Languages and Literatures",
    "Social Psychology",
    "Social Work",
    "Sociology",
    "Soil Science",
    "Sound Engineering",
    "South Asian Studies",
    "Southeast Asia Studies",
    "Spanish Major",
    "Special Education",
    "Speech Pathology",
    "Sport and Leisure Studies",
    "Sports Management",
    "Statistics Major",
    "Surveying",
    "Sustainable Resource Management",
    "Teacher Education",
    "Teaching English as a Second Language",
    "Technical  Writing",
    "Technology Education",
    "Textile Engineering",
    "Theatre",
    "Theology",
    "Tourism",
    "Toxicology",
    "Turfgrass Science",
    "Urban Planning",
    "Urban Studies",
    "Visual Communication",
    "Voice",
    "Web Design",
    "Webmaster and Web Management",
    "Welding Engineering",
    "Wildlife Management",
    "Women's Studies",
    "Youth Ministries",
    "Zoology",
];

export { commonMajors };